(function (window, $) {
  class Radio {
    constructor(options) {
      this.options = $.extend(
        {
          value: "",
          checked: false,
          disabled: false,
          label: "",
          labelSlot: null,
          container: null,
          cancelSelect: false,
        },
        options,
      );

      this.value = this.options.value;
      this.emitter = window.useEmitter();
      this.$html = null;
      this.init();
    }

    init() {
      this.render();
      this.bindEvents();
      if (this.options.container) {
        $(this.options.container).append(this.$html);
      }
    }

    render() {
      const { checked, disabled, label, labelSlot } = this.options;

      const $wrapper = $("<div>").addClass("custom-radio");
      if (disabled) {
        $wrapper.addClass("is-disabled");
      }

      const iconClass = checked ? "icon-icon-xuanzhongxiang" : "icon-weixuanzhong";
      const $icon = $("<i>").addClass(`iconfont ${iconClass} radio-icon`);

      const $label = $("<span>").addClass(`radio-label ${checked ? "checked" : ""}`);

      if (labelSlot) {
        if (typeof labelSlot === "function") {
          $label.html(labelSlot(this.options));
        }
        if (typeof labelSlot === "string") {
          $label.html(labelSlot);
        } else if (labelSlot instanceof jQuery || (labelSlot && labelSlot.nodeType)) {
          $label.append(labelSlot);
        }
      } else {
        $label.text(label);
      }

      $wrapper.append($icon).append($label);
      this.$html = $wrapper;
    }

    bindEvents() {
      this.$html.on("click", () => {
        if (this.options.disabled) return;
        this.select();
      });
    }

    select() {
      if (this.options.cancelSelect) {
        this.setValue(!this.options.checked, true);
      } else {
        if (!this.options.checked) {
          this.setValue(true, true);
        }
      }
    }

    getValue() {
      return this.options.checked;
    }

    setValue(checked, emit = false) {
      if (this.options.checked === checked) return;
      this.options.checked = checked;
      this.updateIcon();
      emit && this.emitter.emit("change", checked, this.value);
    }

    updateIcon() {
      const $icon = this.$html.find(".radio-icon");
      const $label = this.$html.find(".radio-label");
      $icon.removeClass("icon-icon-xuanzhongxiang icon-weixuanzhong");
      if (this.options.checked) {
        $icon.addClass("icon-icon-xuanzhongxiang");
        $label.addClass("checked");
      } else {
        $icon.addClass("icon-weixuanzhong");
        $label.removeClass("checked");
      }
    }

    setDisabled(disabled) {
      this.options.disabled = disabled;
      if (disabled) {
        this.$html.addClass("is-disabled");
      } else {
        this.$html.removeClass("is-disabled");
      }
    }

    updateData(options) {
      $.extend(this.options, options);
      if (options.hasOwnProperty("checked")) {
        this.setValue(options.checked);
      }
      if (options.hasOwnProperty("disabled")) {
        this.setDisabled(options.disabled);
      }
      if (options.hasOwnProperty("label") || options.hasOwnProperty("labelSlot")) {
        const $label = this.$html.find(".radio-label");
        $label.empty();
        const { label, labelSlot } = this.options;
        if (labelSlot) {
          if (typeof labelSlot === "string") {
            $label.html(labelSlot);
          } else if (labelSlot instanceof jQuery || (labelSlot && labelSlot.nodeType)) {
            $label.append(labelSlot);
          }
        } else {
          $label.text(label);
        }
      }
    }
  }

  window.Radio = Radio;
})(window, jQuery);
